import { atom } from 'jotai';

export const techblogSearchKeyword = atom<{
  tag: string;
  keyword: string;
}>({
  tag: '',
  keyword: '',
});

export const techblogPage = atom(1);

export const lastClickedTechblog = atom({
  id: 0,
  companyId: 0,
  title: '',
  date: new Date(),
});
